import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { IUserLocal, Level } from '@core/api-types/user';
import { LOCAL_STORAGE_KEY, LocalStorageService } from '@core/services/localstorage.service';

export const AdminGuard = () => {
    const router = inject(Router);
    const storage = inject(LocalStorageService);

    const user = storage.getObject<IUserLocal>(LOCAL_STORAGE_KEY.USER);

    if (user.Level !== Level.ADMIN) {
        router.navigate(['403']);
        return false;
    }
    return true;
};
